import React from 'react';
import dayjs from 'dayjs';
import classnames from 'classnames';
import { Theme } from '@/sunzi';
import MultiPhotoFactory, { MultiPhotoContentProps, MultiPhotoPreviewProps, MultiPhotoProps } from './factory';
import styles from './style.less';

const Content: React.FC<MultiPhotoContentProps> = ({ theme, sourceList, activeIndex }) => (
  <div className={classnames(styles.content, {
		[styles.contentLight]: theme === Theme.light
	})}>
		{sourceList[activeIndex] &&
			<img src={sourceList[activeIndex].handle} />
		}
	</div>
);

const PreviewContent: React.FC<MultiPhotoPreviewProps> = ({ theme, sourceList }) => (
	<div className={classnames(styles.preview, {
		[styles.previewLight]: theme === Theme.light
	})}>
		{sourceList.map((item, index) => (
			<div key={index} className={styles.imageWrapper}>
				<img src={item.handle} />
			</div>
		))}
	</div>
);
export { default as SpotifyCodeFilm } from './spotify-code-film';
export const formatTime = (time: number) => dayjs(time).subtract(1, 's').format('mm:ss');

const MultiPhotoFactoryComponent: React.FC<Omit<MultiPhotoProps, 'Content' | 'PreviewContent'>> = (props) => {
  return <MultiPhotoFactory {...props} Content={Content} PreviewContent={PreviewContent} />
}

export default MultiPhotoFactoryComponent;
